import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './styles.module.css';

interface ShowAllButtonProps {
    onClick: () => void;
    className: string;
}

export const ShowAllButton: FC<ShowAllButtonProps> = ({ onClick, className }) => (
    <div className={className}>
        <button className={styles.showAllButton} onClick={onClick}>
            <FormattedMessage
                id="components.PlayerSkin.eb92025cb8c66f1850c13a9b602a1856"
                defaultMessage="Show all"
                description="Текст кнопки 'Показать все' в плеере"
            />
        </button>
    </div>
);
